import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const ChoiceContext = createContext()

const ChoiceProvider = ({ children }) => {
    const { headers, toast, restaurantId } = useAuth();

    const getAllChoices = async (filter) => {
        try {
            const { limit, totalRenderedRecords, filter: filterChoice } = filter

            let { data } = await axios.get(`${baseURL}/choice/list?limit=${limit ? limit : null}&totalRenderedRecords=${totalRenderedRecords >= 0 ? totalRenderedRecords : null}&restaurant_id=${restaurantId ? restaurantId : null}&filter=${filterChoice !== '' ? filterChoice : null}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Choice', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Get Single Choice
    const getSingleChoice = async (id) => {
        try {
            let { data } = await axios.get(`${baseURL}/choice/single-choice/${id}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Choice', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    //Create Choice
    const createChoice = async (choiceDetails) => {
        try {
            const { data } = await axios.post(`${baseURL}/choice/create`, choiceDetails, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Choice', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Choice', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Choice', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Choice', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Choice', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //Update Choice
    const updateChoice = async (id, choiceDetails) => {
        try {
            const { data } = await axios.put(`${baseURL}/choice/update/${id}`, choiceDetails, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Choice', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Choice', detail: data.message, life: 3000 })
            }
        } catch (error) {
            if (error.response) {
                const errors = error.response.data.errors;
                if (errors && Array.isArray(errors) && errors.length > 0) {
                    if (errors.length > 1) {
                        toast.current?.show({ severity: 'error', summary: 'Choice', detail: "Please fill all mandatory fields.", life: 3000 })
                    } else {
                        toast.current?.show({ severity: 'error', summary: 'Choice', detail: errors[0].msg, life: 3000 })
                    }
                }
            } else {
                toast.current?.show({ severity: 'error', summary: 'Choice', detail: 'An error occurred. Please try again later.', life: 3000 })
            }
        }
    }

    //Delete Category
    const deleteChoice = async (id) => {
        try {
            const { data } = await axios.delete(`${baseURL}/choice/delete/${id}`, { headers });
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Choice', detail: data.message, life: 3000 })
                }, 500);
                return data
            } else {
                toast.current?.show({ severity: 'error', summary: 'Choice', detail: data.message, life: 3000 })
                return data;
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Choice', detail: 'An error occurred. Please try again later.', life: 3000 })
        }
    }

    return (
        <ChoiceContext.Provider value={{ getAllChoices, createChoice, updateChoice, getSingleChoice, deleteChoice }}>
            {children}
        </ChoiceContext.Provider>
    )
}

const useChoice = () => useContext(ChoiceContext)

export { useChoice, ChoiceProvider }